import { RecursivePartial } from '../../../types';
import { api } from '../../api';
import { ApiResponse } from '../Utilities';
import { CreateUpdateDeleteViewModel, DocumentLayoutViewModel } from '../ViewModels';

export class LayoutApi {
    private route = '/Layout';

    public postLayout(body: RecursivePartial<DocumentLayoutViewModel>): ApiResponse<CreateUpdateDeleteViewModel> {
        return api().post(this.route, body);
    }

    public putLayout(body: RecursivePartial<DocumentLayoutViewModel>): ApiResponse<CreateUpdateDeleteViewModel> {
        return api().put(this.route, body);
    }

    public deleteLayoutField(fieldDictionaryId: number): ApiResponse<CreateUpdateDeleteViewModel> {
        return api().delete(`${this.route}/Field/${fieldDictionaryId}`);
    }
}
